import { render, staticRenderFns } from "./AdvancePaymentsList.vue?vue&type=template&id=74786d1b"
import script from "./AdvancePaymentsList.vue?vue&type=script&lang=js"
export * from "./AdvancePaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports